import React, { useMemo } from "react";

const formatDeadline = (value) => {
    if (!value) { return "—"; }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) { return value; }

    return date.toLocaleDateString([], {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const UpcomingDeadlines = ({ items = [], loading = false }) => {
    const deadlines = useMemo(() => {
        const now = new Date();

        return [...items]
            .filter((item) => {
                const date = new Date(item.due_date || item.calendar_date);

                return (
                    !Number.isNaN(date.getTime()) &&
                    date >= now &&
                    item.status !== "completed" &&
                    item.status !== "cancelled"
                );
            })
            .sort(
                (a, b) =>
                    new Date(a.due_date || a.calendar_date)
                    - new Date(b.due_date || b.calendar_date)
            )
            .slice(0, 10);
    }, [items]);

    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "20px",
                height: "fit-content",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                }}
            >
                <h3 style={{ margin: 0 }}>
                    Upcoming Deadlines
                </h3>

                <span
                    style={{
                        fontSize: "13px",
                        color: "#64748b",
                    }}
                >
                    {deadlines.length}
                </span>
            </div>

            {loading ? (
                <div
                    style={{
                        padding: "24px 0",
                        color: "#64748b",
                    }}
                >
                    Loading deadlines...
                </div>
            ) : deadlines.length === 0 ? (
                <div
                    style={{
                        padding: "24px 0",
                        color: "#64748b",
                    }}
                >
                    No upcoming deadlines.
                </div>
            ) : (
                deadlines.map((item) => (
                    <div
                        key={`${item.id}-${item.calendar_date}`}
                        style={{
                            padding: "12px 0",
                            borderBottom: "1px solid #f1f5f9",
                        }}
                    >
                        <strong>{item.title}</strong>

                        <div
                            style={{
                                color: "#64748b",
                                fontSize: "14px",
                                marginTop: "3px",
                            }}
                        >
                            {item.business_name || "—"}
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                                marginTop: "6px",
                                fontSize: "13px",
                            }}
                        >
                            <span>
                                {formatDeadline(
                                    item.due_date ||
                                        item.calendar_date
                                )}
                            </span>

                            <span>
                                {item.priority || "—"}
                            </span>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default UpcomingDeadlines;
